module.exports = __webpack_public_path__ + "static/media/Done-6.1cd01887.png";